import React, { useState, useContext, useEffect } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { fx_FB_UpdateUserLastRole } from "../functions/Fx_FirebaseUpdateFunctions";
import {
  IonHeader,
  IonToolbar,
  IonAvatar,
  IonToggle,
  IonBadge,
  IonButton,
  IonIcon,
  IonTitle,
  IonButtons,
  IonAlert,
} from "@ionic/react";
import { SchedJobContext } from "../context/JobContextScheduler";
import { WerkerJobContext } from "../context/JobContextWerker";
import { HEADERTEXT_TYPES } from "../functions/postActionTypes";
import { NoConnectionMsg } from "./NoConnection";
import { useHistory } from "react-router-dom";
import { arrowBack } from "ionicons/icons";

export const WerkerSchedulerHeader: React.FC<{ title: any; endSlot?: React.ReactNode; forceShowBack?: boolean; subheader?: React.ReactNode }> = ({ title, endSlot, forceShowBack, subheader }) => {
  const { profile, networkConnection } = useContext(ProfileContext);
  const history = useHistory<any>();
  const [headerColor, setHeaderColor] = useState("");

  const [headerText, setHeaderText] = useState("");

  const blurFocusedElement = () => {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
      activeElement.blur();
    }
  };

  const { badgeCountHeaderToggleSchedulerContext } = useContext(SchedJobContext);
  const { badgeCountHeaderToggleWerkerContext } = useContext(WerkerJobContext);

  const LinkToProfile = () => {
    blurFocusedElement();
    history.push({
      pathname: `/Profile`,
    });
  };

  function flipTheRole() {
    let headerStmt: boolean = false;

    if (profile.UserLastRoleScheduler === true) {
      headerStmt = false;
    } else if (profile.UserLastRoleScheduler === false) {
      headerStmt = true;
    } else {
      headerStmt = false;
    }

    // Show paywall when switching TO scheduler mode if not subscribed.
    // If Scheduler Orientation hasn't been seen yet, skip — let the orientation
    // run first (triggered by Home's useEffect), and the Paywall will follow
    // at the end of orientation. If orientation has already been seen, go
    // straight to Paywall on every toggle while unsubscribed.
    if (headerStmt === true && profile.SubscriptionType !== "Scheduler" && profile.OnboardingSchedulerSeen === true) {
      history.push({
        pathname: "/Paywall",
        state: { cameFrom: "Home.Scheduler" },
      });
    }

    fx_FB_UpdateUserLastRole(profile.UserId, headerStmt);
  }

  useEffect(() => {
    if (profile.UserLastRoleScheduler === true) {
      setHeaderColor("secondwarning");
    } else {
      setHeaderColor("warning");
    }

    switch (title) {
      case HEADERTEXT_TYPES.Home:
      case "Home":
        if (profile.UserLastRoleScheduler === true) {
          setHeaderText("Scheduler");
        } else {
          setHeaderText("WerkApp");
        }
        return;

      case HEADERTEXT_TYPES.Associates:
        setHeaderText(HEADERTEXT_TYPES.Associates);
        return;

      case HEADERTEXT_TYPES.Profile:
        setHeaderText(HEADERTEXT_TYPES.Profile);
        return;

      case HEADERTEXT_TYPES.AssociatesProfile:
        setHeaderText(HEADERTEXT_TYPES.AssociatesProfile);
        return;

      case HEADERTEXT_TYPES.EditJob:
        setHeaderText(HEADERTEXT_TYPES.EditJob);
        return;

      case HEADERTEXT_TYPES.EditProfile:
        setHeaderText(HEADERTEXT_TYPES.EditProfile);
        return;

      case HEADERTEXT_TYPES.ShiftDetails:
        setHeaderText(HEADERTEXT_TYPES.ShiftDetails);
        return;

      case HEADERTEXT_TYPES.ScheduleJob:
        setHeaderText(HEADERTEXT_TYPES.ScheduleJob);
        return;

      case HEADERTEXT_TYPES.Community:
        setHeaderText(HEADERTEXT_TYPES.Community);
        return;

      case HEADERTEXT_TYPES.AnnouncementSelectWerkers:
        setHeaderText(HEADERTEXT_TYPES.AnnouncementSelectWerkers);
        return;

      case HEADERTEXT_TYPES.Announcement:
        setHeaderText(HEADERTEXT_TYPES.Announcement);
        return;

      case HEADERTEXT_TYPES.ChooseWerkers:
        setHeaderText(HEADERTEXT_TYPES.ChooseWerkers);
        return;

      case HEADERTEXT_TYPES.Chat:
        setHeaderText(HEADERTEXT_TYPES.Chat);
        return;

      case HEADERTEXT_TYPES.Chats:
      case "Messages":
        setHeaderText("Messages");
        return;

      case HEADERTEXT_TYPES.CloneJob:
        setHeaderText(HEADERTEXT_TYPES.CloneJob);
        return;

      case HEADERTEXT_TYPES.AddWerkerToShift:
        setHeaderText(HEADERTEXT_TYPES.AddWerkerToShift);
        return;

      case HEADERTEXT_TYPES.AdminView:
        setHeaderText(HEADERTEXT_TYPES.AdminView);
        return;

      case HEADERTEXT_TYPES.NewMessage:
        setHeaderText(HEADERTEXT_TYPES.NewMessage);
        return;

      case "Create Announcement":
        setHeaderText("Create Announcement");
        return;

      case "Edit Announcement":
        setHeaderText("Edit Announcement");
        return;

      case "Select Audience":
        setHeaderText("Select Audience");
        return;

      case "Announcement Detail":
      case "Announcement":
        setHeaderText("Announcement");
        return;

      case "Notifications":
        setHeaderText("Notifications");
        return;

      case HEADERTEXT_TYPES.Payments:
      case "Payments":
        setHeaderText("Payments");
        return;

      default:
        setHeaderText(String(title || ""));
        return;
    }
  }, [profile, title]);

  const showBackButton =
    forceShowBack ||
    headerText === HEADERTEXT_TYPES.AssociatesProfile ||
    headerText === HEADERTEXT_TYPES.ShiftDetails ||
    headerText === HEADERTEXT_TYPES.EditJob ||
    headerText === HEADERTEXT_TYPES.Chat ||
    headerText === HEADERTEXT_TYPES.EditProfile ||
    headerText === HEADERTEXT_TYPES.ScheduleJob ||
    headerText === HEADERTEXT_TYPES.CloneJob ||
    headerText === HEADERTEXT_TYPES.AddWerkerToShift ||
    headerText === HEADERTEXT_TYPES.NewMessage ||
    headerText === HEADERTEXT_TYPES.ChooseWerkers ||
    headerText === HEADERTEXT_TYPES.AnnouncementSelectWerkers ||
    headerText === HEADERTEXT_TYPES.Announcement ||
    headerText === "Create Announcement" ||
    headerText === "Edit Announcement" ||
    headerText === "Select Audience" ||
    headerText === "Announcement" ||
    headerText === HEADERTEXT_TYPES.Payments ||
    headerText === "Payments" ||
    headerText === "Calendar";

  const isMainTabPage =
    title === "Home" ||
    title === HEADERTEXT_TYPES.Chats ||
    title === "Messages" ||
    title === HEADERTEXT_TYPES.Associates ||
    title === "Notifications" ||
    title === HEADERTEXT_TYPES.Profile;

  const schedulerBadgeCount = badgeCountHeaderToggleSchedulerContext;
  const werkerBadgeCount = badgeCountHeaderToggleWerkerContext;

  // One-time welcome popup — DEACTIVATED for now
  // TODO: Rebuild as multi-step onboarding flow:
  //   1. "Go to Associates, search/request associates"
  //   2. "DM associates, receive jobs & announcements from schedulers"
  //   3. "Toggle to switch to Scheduler mode"
  //   4. (On first scheduler visit) "Tap Add FAB to create a job"
  //   5. "In Associates > Crews, create a crew to send jobs/announcements by group"
  //   6. "How to send announcements"
  const [showWelcome, setShowWelcome] = useState(false);
  const welcomeCheckedRef = React.useRef(false);
  /* useEffect(() => {
    if (!welcomeCheckedRef.current && isMainTabPage && profile.UserId) {
      welcomeCheckedRef.current = true;
      const key = `werkapp_welcome_seen_${profile.UserId}`;
      if (!localStorage.getItem(key)) {
        setShowWelcome(true);
      }
    }
  }, [isMainTabPage, profile.UserId]); */

  const dismissWelcome = () => {
    setShowWelcome(false);
    if (profile.UserId) {
      localStorage.setItem(`werkapp_welcome_seen_${profile.UserId}`, "1");
    }
  };

  return (
    <React.Fragment>
      <IonHeader translucent={false}>
        <IonToolbar
          color={headerColor}
        >
          {/* START */}
          <IonButtons
            slot="start"
          >
            {showBackButton ? (
              <IonButton
                onClick={() => {
                  blurFocusedElement();
                  history.goBack();
                }}
                fill="clear"
                className="waBackBtn"
              >
                <IonIcon
                  size="large"
                  className="backArrowColor"
                  icon={arrowBack}
                />
              </IonButton>
            ) : isMainTabPage ? (
              <div className="waToggleWrap" style={{ display: "flex", alignItems: "center", paddingLeft: 6 }}>
                <IonToggle
                  checked={profile.UserLastRoleScheduler === true}
                  onIonChange={() => {
                    flipTheRole();
                  }}
                  color="danger"
                />

                {/* Overlay badge so it never moves the toggle */}
                {profile.UserLastRoleScheduler === false && schedulerBadgeCount > 0 && (
                  <IonBadge
                    color="danger"
                    className="waToggleBadge"
                  >
                    {schedulerBadgeCount}
                  </IonBadge>
                )}

                {profile.UserLastRoleScheduler === true && werkerBadgeCount > 0 && (
                  <IonBadge
                    color="danger"
                    className="waToggleBadge"
                  >
                    {werkerBadgeCount}
                  </IonBadge>
                )}
              </div>
            ) : null}
          </IonButtons>

          {/* CENTER TITLE */}
          <IonTitle
            className="waHeaderTitle"
          >
            {headerText}
          </IonTitle>

          {/* END */}
          <IonButtons
            slot="end"
          >
            {isMainTabPage ? (
              <IonButton
                fill="clear"
                className="waAvatarBtn"
                onClick={LinkToProfile}
              >
                <IonAvatar
                  className="tinyavatar waAvatar"
                >
                  <img src={profile.ProfilePicURL} alt="" />
                </IonAvatar>
              </IonButton>
            ) : endSlot ? (
              <>{endSlot}</>
            ) : null}
          </IonButtons>
        </IonToolbar>
        {subheader}
      </IonHeader>

      {networkConnection === false && <NoConnectionMsg />}

      <IonAlert
        isOpen={showWelcome}
        onDidDismiss={dismissWelcome}
        header="Welcome to WerkApp!"
        message="Use the <strong>W / S toggle</strong> in the top left to switch between <strong>Werker</strong> mode (find and work jobs) and <strong>Scheduler</strong> mode (create and manage jobs).<br/><br/>The header color changes to let you know which mode you're in — <strong>yellow = Werker</strong>, <strong>orange = Scheduler</strong>."
        buttons={["Got it"]}
      />
    </React.Fragment>
  );
};
